import useAuth from "@/lib/auth/useAuth";
import useIsMobile from "@/lib/utils/useIsMobile";
import { Skeleton } from "@heroui/react";
import {
    createFileRoute,
    useLocation,
    useNavigate,
} from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
    component: RouteComponent,
});

function RouteComponent() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const { isMobile } = useIsMobile();

    useEffect(() => {
        if (!!user && location.pathname === "/") {
            if (
                window.localStorage.getItem("oldNTime") == "false" ||
                isMobile
            ) {
                navigate({ to: "/dashboard/home" });
            } else {
                navigate({
                    to: "/ntimev1/$",
                    params: { _splat: "dashboard/home" },
                });
            }
        }
    }, [navigate, user, location.pathname, isMobile]);
    return (
        <div>
            <Skeleton className="h-screen w-screen" />
        </div>
    );
}
